export function whenDocumentReady(callbackFunction) {
    if (document.readyState !== `loading`) {
        callbackFunction();
    } else {
        document.addEventListener(`DOMContentLoaded`, () => {
            callbackFunction();
        });
    }
}